export const showPayment = (payment_method: number | string) => {

    if(payment_method == -1) {
        return "Credit"
    }

    if(payment_method == 'crdt') {
        return "Credit"
    }

    if (payment_method == 111) {
        return "Test Pay"
    }

    return "Stripe - Card";

}
